import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import { useSelector, shallowEqual } from 'react-redux'

import { formatCurrency } from '../../helpers/currencyHelpers'
import ConfigContext from '../../contexts/configContext'
import Alert from '../alert'
import { translate } from '../../helpers/stringHelpers'

const FeesAlert = ({ listingUuid }) => {
  const { locale } = useContext(ConfigContext)
  const {
    auctionUuid,
    buyersPremium,
    buyersPremiumTaxRate,
    charges,
    chargesTaxRate,
    hammerTaxRate,
    isMarketplace
  } = useSelector(state => state.lots.listings[listingUuid], shallowEqual)
  const marketplaceFriendlyAuctionUuid = isMarketplace ? 'marketplace' : auctionUuid
  const currencyCode = useSelector(state => listingUuid && state.listingSales.sales[listingUuid].currencyCode)
  const isSalesTaxRequired = useSelector(state => state.auctions.information[marketplaceFriendlyAuctionUuid]?.salesTaxRequired || false)
  const customFees = translate('JspPublicCodes_CONFIRMATION_FEES_CUSTOM_HTML')

  return hammerTaxRate || buyersPremium || charges || !isSalesTaxRequired
    ? (
      <Alert color='warning' className='fees-alert'>
        {isSalesTaxRequired
          ? ([
            <strong key='feeLabel'>{translate('JspPublicCodes_JSP_AUCTION_INFORMATION_ADDITIONAL_FEES')}</strong>,
            <ul key='feeList'>
              {hammerTaxRate
                ? (
                  <li>
                    {translate('JspPublicCodes_JSP_AUCTION_INFORMATION_HAMMER_TAX_RATE')}: <strong className='lot__fee--hammer-tax'>{hammerTaxRate}%</strong>
                  </li>
                  )
                : null}
              {buyersPremium
                ? (
                  <li>
                    {translate('JspPublicCodes_JSP_AUCTION_INFORMATION_BUYERS_PREMIUM')}: <strong className='lot__fee--bp'>{buyersPremium}%</strong>
                    {buyersPremiumTaxRate
                      ? (
                        <small className='lot__fee--bp-tax'>(+<strong>{buyersPremiumTaxRate}%</strong> {translate('JspPublicCodes_JSP_AUCTION_INFORMATION_BP_TAX_RATE')})</small>)
                      : null}
                  </li>
                  )
                : null}
              {charges
                ? (
                  <li>
                    {translate('JspPublicCodes_JSP_AUCTION_INFORMATION_CHARGES')}: <strong className='lot__fee--charges'>{formatCurrency(locale, currencyCode, charges)}</strong>
                    {chargesTaxRate
                      ? (
                        <small>(+<strong className='lot__fee--charges-tax'>{chargesTaxRate}%</strong> {translate('JspPublicCodes_JSP_AUCTION_INFORMATION_CHARGES_TAX_RATE')})</small>)
                      : null}
                  </li>
                  )
                : null}
            </ul>
            ])
          : (
            <div dangerouslySetInnerHTML={{
              __html: translate('JspPublicCodes_JSP_AUCTION_INFORMATION_SALES_TAX_NOT_REQUIRED_MESSAGE')
            }}
            />
            )}
            {customFees && customFees !== String.fromCharCode(160) // detects if content is only a space
              ? (
                <span className='sale-info__content--fees-custom' dangerouslySetInnerHTML={{ __html: customFees }} />
                )
              : null}
      </Alert>
      )
    : null
}

FeesAlert.propTypes = {
  listingUuid: PropTypes.string.isRequired
}

export default React.memo(FeesAlert)
